import { lighten } from "@mui/material/styles";

const priorityColors = theme => ({
  lowPriority: {
    backgroundColor: ["#5E7B5E", "!important"],
    color: theme.palette.getContrastText("#5E7B5E"),
    "&:hover": {
      backgroundColor: [lighten("#5E7B5E", 0.1), "!important"],
      color: "white"
    }
  },
  mediumPriority: {
    backgroundColor: ["#EA8C1D", "!important"],
    color: theme.palette.getContrastText("#EA8C1D"),
    "&:hover": {
      backgroundColor: lighten("#EA8C1D", 0.1),
      color: theme.palette.getContrastText(lighten("#EA8C1D", 0.1))
    }
  },
  highPriority: {
    backgroundColor: ["#D9514B", "!important"],
    color: theme.palette.getContrastText("#D9514B"),
    "&:hover": {
      backgroundColor: lighten("#D9514B", 0.1),
      color: theme.palette.getContrastText(lighten("#D9514B", 0.1))
    }
  },
  parkedPriority: {
    backgroundColor: ["#3D4EAF", "!important"],
    color: theme.palette.getContrastText("#3D4EAF"),
    "&:hover": {
      backgroundColor: lighten("#3D4EAF", 0.1),
      color: theme.palette.getContrastText(lighten("#3D4EAF", 0.1))
    }
  }
});

export function getColorStyleForName(name) {
  switch (name) {
    case "Highest":
    case "High":
      return "highPriority";
    case "Normal":
      return "mediumPriority";
    case "Parked":
      return "parkedPriority";
    case "Low":
    case "Lowest":
    default:
      return "lowPriority";
  }
}

export default priorityColors;
